(() => {
'use strict';
const $ = id => document.getElementById('gh-'+id);
const L = window.OTTAR;
const LOGO_EL=document.querySelector(".gh-ottar .card-logo");
let LOGO_URI="";   // må vere data: - eksterne URL-ar blir blokkerte i SVG-render
const logoReady=(async()=>{
 try{
  if(!LOGO_EL||!LOGO_EL.src)return;
  const b=await fetch(LOGO_EL.src,{mode:"cors"}).then(r=>r.blob());
  LOGO_URI=await new Promise(res=>{const fr=new FileReader();fr.onload=()=>res(fr.result);fr.onerror=()=>res("");fr.readAsDataURL(b)});
 }catch(e){LOGO_URI=""}
})();

// Dialekt-tegnnamn (UI) -> zodiacBanter-nøkkel i biblioteket.
const SIGN_KEY={
 "Vatnkarn":"vannmannen","Feskan":"fiskene","Væreiarn":"vaeren","Tyrn":"tyren",
 "Tvellingan":"tvillingene","Kræpsn":"krepsen","Løva":"loeven","Jomfrua":"jomfruen",
 "Vækta":"vekten","Skorpion":"skorpionen","Skjøttarn":"skytten","Steinbiten":"steinbukken"
};
// Innhaldspoolar motoren trekk fritt frå (ingen tema lenger).
const POOLS=["observations","kaiaStories","personal","stikk","ronny","skatteetaten",
 "gulls","havet","kaffe","kaia","soring","vaeret","batmotor","livet","marta",
 "gamleSjarken","stormen97","forsteKjarlighet","bamse","mysterier","nakneFolelser",
 "johannes","faren"];

// Dagens fangst: vekta nivå. Fisk er kvardagen, jackpot og tull er sjeldan.
const FANGST={
 fisk:["1 torsk","2 torsk","3 torsk","4 torsk","1 sei","2 sei","3 sei","4 sei",
  "1 hyse","2 hyse","1 uer","2 uer","1 steinbit","1 kveite","2 flyndra","6 sild",
  "4 makrell","2 lyr","1 brosme","3 krabba","1 hummer","2 sjøkreps"],
 rusk:["Ingenting","Ingenting","En støvel","To støvla","Ei plastpose","Et tau",
  "Ei colaboks","Ei ølboks","En gammel teine","Et garn","En fiskkasse","Ei bøye",
  "En redningsvest","En hanske","Ei plastflaska","Et bildekk","En sykkel",
  "En handlevogn","Ei åre","Ei oljekanne","Et kjøleskap"],
 ottar:["Naboen sin teina","Svigermor si veske","En mista mobil","En tom snusboks",
  "Ei grillpølse","En Crocs","En grillrist","Ei kaffekanne","Ei regnjakke",
  "En fiskar som va meir uheldig enn dæ"],
 jackpot:["Ei storkveite","Laks på 14 kilo","Kongekrabbe","Hummer","Ei flaske med melding",
  "En gammel sølvring","Gullklokka","Ei skattkiste","Dagens rekordfangst",
  "Alt beit på første kast"],
 jordet:["Ei havfrue","En sel som flira av dæ","Kaptein Sabeltann","En ubåt",
  "En russisk spion","En pingvin","Monsteret i Loch Ness","Et sjøuhyre","En UFO",
  "Poseidon sin gaffel","En kval som nekta å flytt sæ","Ei badeand",
  "Julenissen på ferie","En sjøorm","Et kunstverk fra havets bunn"]
};
// 56 % fisk, 24 % rusk, 10 % Ottar, 6 % jackpot, 4 % heilt på jordet.
function fangst(r){
 const p=r()*100;
 const k = p<56?"fisk" : p<80?"rusk" : p<90?"ottar" : p<96?"jackpot" : "jordet";
 return choose(FANGST[k],r);
}

// Sesong- og tidspoolar: berre aktuelle når dei faktisk passar.
// Ottar snakkar ikkje om mørketid i juni.
function paaske(aar){ // computus
 const a=aar%19,b=Math.floor(aar/100),c=aar%100,d=Math.floor(b/4),e=b%4;
 const f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30;
 const i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451);
 const md=h+l-7*m+114;
 return new Date(aar,Math.floor(md/31)-1,(md%31)+1);
}
function kontekstPoolar(){
 const d=new Date(), m=d.getMonth()+1, t=d.getHours(), ut=[];
 if(m===12||m<=2) ut.push("winter");
 if(m>=3&&m<=5)   ut.push("spring");
 if(m>=6&&m<=8)   ut.push("summer");
 if(m>=9&&m<=11)  ut.push("autumn");
 if(m>=11||m===1) ut.push("morketid");
 if(m>=5&&m<=7)   ut.push("midnattssol");
 if(m>=1&&m<=4)   ut.push("skrei");
 if(m===12&&d.getDate()>=1) ut.push("christmas");
 const p=paaske(d.getFullYear()), diff=Math.abs(d-p)/86400000;
 if(diff<=10) ut.push("easter");
 if(t>=4&&t<10)  ut.push("morning");
 if(t>=22||t<4)  ut.push("night");
 return ut.filter(k=>Array.isArray(L[k])&&L[k].length>1);
}

let current=null;
let pngBlob=null;   // ferdig PNG for deling/nedlasting
let pngUrl=null;

function choose(a,r){return a[Math.floor(r()*a.length)]}
function int(a,b,r){return Math.floor(r()*(b-a+1))+a}
// Trekk eit sammenhengande par (oppsett + punchline) frå ein pool.
function couplet(pool,r){
 if(!pool||!pool.length)return[];
 if(pool.length===1)return[pool[0]];
 const i=int(0,Math.floor((pool.length-2)/2),r)*2;
 return[pool[i],pool[i+1]];
}
// Sl\u00e5 eit par saman til eitt avsnitt (pent handtert "..."-par).
// Har begge linjene innleiingsfrase, blir berre den f\u00f8rste brukt \u2013 to
// tidsangivingar etter kvarandre les som maskin, ikkje som Ottar.
function joinCouplet(pool,r){
 const c=couplet(pool,r);
 if(c.length<2)return c[0]||"";
 let a=c[0],b=c[1];
 if(/(\.\.\.|\u2026)\s*$/.test(a)&&/^\s*(\.\.\.|\u2026)/.test(b))b=b.replace(/^\s*(\.\.\.|\u2026)\s*/,"");
 return a+" "+b;
}

function build(){
 const sign=$("sign").value;
 const zkey=SIGN_KEY[sign];
 const r=Math.random;

 // Sett saman dommen: kvart par (oppsett + punchline) blir eitt avsnitt.
 // PREFIKS + HOVUDTEKST + AVSLUTNING.
 // Prefikset set stemninga og st\u00e5r aldri \u00e5leine \u2013 det opnar f\u00f8rste avsnitt.
 const body=[];
 const pfx = (L.prefixes&&L.prefixes.length) ? choose(L.prefixes,r) : "";
 const opening = joinCouplet(L.openings,r);
 body.push(pfx ? pfx+" "+opening : opening);
 const zb=L.zodiacBanter&&L.zodiacBanter[zkey];
 if(zb&&zb.length)body.push(joinCouplet(zb,r));
 const nt=r()<0.5?1:2;
 for(let t=0;t<nt;t++){const s=joinCouplet(L[choose(POOLS,r)],r);if(s)body.push(s)}

 // ~40 % sjanse for eit avsnitt som passar årstida eller tida på døgnet
 const kp=kontekstPoolar();
 if(kp.length&&r()<0.4){const s=joinCouplet(L[choose(kp,r)],r);if(s)body.push(s)}

 const special=r()<0.03?choose(L.sjeldne,r):"";

 return{
  sign,
  opening:body[0]||"",
  paragraphs:body.slice(1),
  wisdom:choose(L.wisdom,r),
  ending:choose(L.endings,r),
  special,
  metrics:[["Motvind",int(4,63,r)+"%"],["Kaffebehov",int(4,12,r)+" koppa"],["Haill",int(5,79,r)+"%"],["Dagens fangst",fangst(r)]]
 }
}
function render(){
 current=build();
 $("badge").textContent=current.sign.toUpperCase();
 const ps=[current.opening,...current.paragraphs,current.ending].filter(Boolean);
 $("body").innerHTML=ps.map(x=>"<p>"+escapeHtml(x)+"</p>").join("");
 $("wisdom").textContent="«"+current.wisdom+"»";
 $("metrics").innerHTML=current.metrics.map(x=>'<div class="metric"><small>'+x[0].toUpperCase()+'</small><strong>'+x[1]+'</strong></div>').join("");
 $("special").hidden=!current.special;$("special").textContent=current.special;
 $("status").textContent="";
 buildPng();   // lag bildet i bakgrunnen så deling kan sende det
}
function escapeHtml(s){return s.replace(/[&<>"']/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]))}
function text(){return[current.sign,current.opening,...current.paragraphs,current.ending,"Siste ord: «"+current.wisdom+"»","www.godthaill.com/ottar"].filter(Boolean).join("\n\n")}
// Invitasjon til ein venn - ingen dom, berre eit puff.
const INVITE=[
 "Æ spurte Gammel-Ottar om dagen min. No e det din tur.",
 "Gammel-Ottar sitt på kaia og seier ka han meine. Prøv sjøl.",
 "Du burde høre ka Gammel-Ottar har å sei om dagen din.",
 "Gammel-Ottar lyg aldri. Spørsmåle e om du tåle svaret.",
 "Ta ein tur på kaia. Gammel-Ottar har nokre ord til dæ."
];
function inviteText(){ return choose(INVITE,Math.random)+"\n\nwww.godthaill.com/ottar" }

async function copy(){
 const t=inviteText();
 try{
  if(navigator.share){ await navigator.share({text:t}); return; }
  await navigator.clipboard.writeText(t);
  $("status").textContent="Invitasjon kopiert \u2013 lim inn og send.";
 }catch(e){
  try{ await navigator.clipboard.writeText(t); $("status").textContent="Invitasjon kopiert \u2013 lim inn og send."; }
  catch(e2){ $("status").textContent="Kunne ikkje kopiere automatisk."; }
 }
}

// Brekk tekst i linjer som får plass innenfor maxWidth. Måler mot faktisk font
// via canvas measureText, så brytinga stemmer med det SVG-en faktisk rendrer.
function wrapText(str,maxWidth,font){
 const ctx=wrapText._c||(wrapText._c=document.createElement("canvas").getContext("2d"));
 ctx.font=font;
 const words=String(str).split(/\s+/).filter(Boolean);
 const lines=[];let line="";
 for(const w of words){
  const test=line?line+" "+w:w;
  if(line&&ctx.measureText(test).width>maxWidth){lines.push(line);line=w}
  else line=test;
 }
 if(line)lines.push(line);
 return lines.length?lines:[""];
}
// Mål breidda på ein tekst med gitt font.
wrapText._m=function(str,font){
 const ctx=wrapText._c||(wrapText._c=document.createElement("canvas").getContext("2d"));
 ctx.font=font; return ctx.measureText(String(str)).width;
};

function svgString(){
 const safe=x=>escapeHtml(x);
 const FF='Arial, "Helvetica Neue", Helvetica, sans-serif';
 const paras=[current.opening,...current.paragraphs,current.ending].filter(Boolean);

 // BODY: brekk hver setning, krymp font hvis nødvendig, sentrer blokka vertikalt
 const bodyTop=575,bodyBottom=1170,bodyMax=900,gap=24;
 let fs=44,lh=45,wrapped=[],blockH=0;
 for(fs=44;fs>=20;fs-=2){
  lh=Math.round(fs*1.32);
  wrapped=paras.map(p=>wrapText(p,bodyMax,`700 ${fs}px ${FF}`));
  blockH=wrapped.reduce((h,ls)=>h+ls.length*lh,0)+gap*(wrapped.length-1);
  if(blockH<=bodyBottom-bodyTop)break;
 }
 let y=Math.round(bodyTop+((bodyBottom-bodyTop)-blockH)/2+fs*0.8);
 let body="";
 for(const para of wrapped){
  for(const ln of para){body+=`<text x="540" y="${y}" text-anchor="middle" font-size="${fs}" font-weight="700" fill="white">${safe(ln)}</text>`;y+=lh}
  y+=gap;
 }

 // VISDOM-BOKS: brekk både sitat og avslutning, la boksen vokse med innholdet
 const boxTop=1390,boxX=95,boxW=890,inner=800;
 let wfs=34,wLines=wrapText("«"+current.wisdom+"»",inner,`italic 700 34px ${FF}`);
 while(wLines.length>3&&wfs>26){wfs-=2;wLines=wrapText("«"+current.wisdom+"»",inner,`italic 700 ${wfs}px ${FF}`)}
 const wLH=Math.round(wfs*1.32),firstLine=110,padB=38;
 const boxH=firstLine+(wLines.length-1)*wLH+padB;
 let wy=boxTop+firstLine;
 let wisdom=`<text x="540" y="${boxTop+54}" text-anchor="middle" font-size="26" font-weight="900" letter-spacing="3" fill="#ebc65b">SISTE ORD</text>`;
 for(const ln of wLines){wisdom+=`<text x="540" y="${wy}" text-anchor="middle" font-size="${wfs}" font-style="italic" font-weight="700" fill="white">${safe(ln)}</text>`;wy+=wLH}

 // METRICS: 2x2 boksar mellom teksten og sitatboksen
 let metrics="";
 {const bw=445,bh=84,x0=95,x1=540,y0=1195,gapY=10;
  current.metrics.forEach((m,i)=>{
   const x=(i%2===0)?x0:x1, y=y0+Math.floor(i/2)*(bh+gapY);
   // skaler verdien ned til han får plass i boksen
   let vfs=30; const maxW=bw-44;
   while(vfs>15 && wrapText._m(m[1],`800 ${vfs}px ${FF}`)>maxW) vfs-=1;
   metrics+=`<rect x="${x}" y="${y}" width="${bw}" height="${bh}" rx="16" fill="#0004" stroke="#ffffff35"/>`
          + `<text x="${x+22}" y="${y+34}" font-size="22" font-weight="800" fill="#ffffffbf">${safe(m[0].toUpperCase())}</text>`
          + `<text x="${x+22}" y="${y+70}" font-size="${vfs}" font-weight="800" fill="white">${safe(m[1])}</text>`;
  });}

 const badgeTxt=current.sign.toUpperCase();
 const badge=safe(badgeTxt);
 const bW=Math.round(wrapText(badgeTxt,4000,`900 28px ${FF}`)[0].length*0)+Math.max(260,Math.round(badgeTxt.length*20+120));
 const bX=Math.round((1080-bW)/2);

 return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1080" height="1920" font-family='${FF}'><defs><linearGradient id="g" x2="0" y2="1"><stop stop-color="#183746"/><stop offset="1" stop-color="#081820"/></linearGradient></defs><rect width="1080" height="1920" fill="url(#g)"/>${LOGO_URI?`<image xlink:href="${LOGO_URI}" href="${LOGO_URI}" x="370" y="252" width="340" height="146"/>`:""}<text x="540" y="424" text-anchor="middle" font-size="26" font-weight="900" letter-spacing="6" fill="#ffffff" fill-opacity="0.72">ORAKLET PÅ KAIA</text><rect x="${bX}" y="462" width="${bW}" height="68" rx="34" fill="#ebc65b"/><text x="540" y="507" text-anchor="middle" font-size="28" font-weight="900" fill="#142833">${badge}</text>${body}<rect x="${boxX}" y="${boxTop}" width="${boxW}" height="${boxH}" rx="24" fill="#0005" stroke="#ffffff40"/>${wisdom}${metrics}<text x="540" y="1660" text-anchor="middle" font-size="28" font-weight="800" fill="white">www.godthaill.com/ottar</text></svg>`;
}
// Lag PNG i bakgrunnen og hald den klar for deling/nedlasting.
async function buildPng(){
 try{
  await logoReady;   // vent til logoen er koda som data-URI
  if(pngUrl){URL.revokeObjectURL(pngUrl);pngUrl=null}
  pngBlob=null;
  const svg=svgString();
  const url=URL.createObjectURL(new Blob([svg],{type:"image/svg+xml;charset=utf-8"}));
  const img=new Image();
  img.onload=()=>{
   try{
    const canvas=document.createElement("canvas");
    canvas.width=1080;canvas.height=1920;
    canvas.getContext("2d").drawImage(img,0,0,1080,1920);
    URL.revokeObjectURL(url);
    canvas.toBlob(b=>{ if(b){pngBlob=b;pngUrl=URL.createObjectURL(b)} },"image/png");
   }catch(e){URL.revokeObjectURL(url)}
  };
  img.onerror=()=>URL.revokeObjectURL(url);
  img.src=url;
 }catch(e){}
}
function pngFile(){ return pngBlob? new File([pngBlob],"gammel-ottars-dom.png",{type:"image/png"}) : null }

// Del: send sjølve bildet når det går, elles tekst.
async function share(){
 const f=pngFile();
 try{
  if(f && navigator.canShare && navigator.canShare({files:[f]})){
   await navigator.share({files:[f]});
   return;
  }
  if(navigator.share){ await navigator.share({title:"Gammel-Ottars dom",text:text()}); return; }
  await copy();
 }catch(e){}
}

// Last ned: anker på desktop, visning med "hald inne for å lagre" på mobil.
function showImage(url){
 let box=document.getElementById("gh-imgout");
 if(!box){
  box=document.createElement("div");
  box.id="gh-imgout";
  box.style.cssText="margin-top:14px";
  const card=document.getElementById("gh-card");
  card.parentNode.insertBefore(box,card.nextSibling);
 }
 box.innerHTML='<p style="font-weight:800;margin:0 0 8px">Hald inne på bildet og vel «Lagre bilde».</p><img src="'+url+'" style="width:100%;border-radius:18px;display:block">';
 box.scrollIntoView({behavior:"smooth",block:"start"});
}
function download(){
 if(!pngBlob){ $("status").textContent="Lage bilde… prøv igjen om eit sekund."; buildPng(); return; }
 const touch = window.matchMedia && window.matchMedia("(pointer:coarse)").matches;
 const a=document.createElement("a");
 const supportsDl = "download" in a;
 if(touch || !supportsDl){ showImage(pngUrl); $("status").textContent=""; return; }
 a.href=pngUrl; a.download="gammel-ottars-dom.png"; a.click();
 $("status").textContent="Bilde lasta ned.";
}
$("generate").addEventListener("click",render);
$("sign").addEventListener("change",render);
$("copy").addEventListener("click",copy);$("share").addEventListener("click",share);$("download").addEventListener("click",download);
// Ingen auto-render: startteksten står til brukaren trykker "Spør Ottar".
})();